import React from "react";
import { useTranslation } from "react-i18next";
const videoUrl = process.env.REACT_APP_VIDEO_URL;

export default function MaVideo() {
  const { t } = useTranslation();

  return (
    <>
      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[30px]">
          {/* Section Title */}
          <div className="flex flex-col items-center justify-center gap-[8px] text-center">
            <h2 className="text-[35px] font-bold text-[#3896BE] capitalize">
              {t("MA Chartered Accountants")}
            </h2>
            <div className="flex flex-col gap-[3px] justify-center items-center">
              <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
              <span className="bg-[#3896BE] flex w-[250px] h-[4px]"></span>
              <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
            </div>
          </div>

          {/* Video Section */}
          <div className="flex justify-center items-center">
            <div className="relative w-full rounded-2xl overflow-hidden shadow-[8px_8px_24px_rgba(0,0,0,0.08)]">
              <video
                className="w-full h-auto rounded-2xl"
                controls
                autoPlay
                poster="https://dummyimage.com/1200x675/3896BE/ffffff&text=MA+Video"
              >
                <source src={videoUrl} type="video/mp4" />
                {t("Your browser does not support the video tag.")}
              </video>

              {/* Overlay for a nice effect */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
